"use client";

import { useContext, useEffect, useState } from "react";
import { Navbar } from "./navbar";
import { ScrollContext } from "@/app/hooks/use-scroll";
import useMobile from "@/app/hooks/use-mobile";
import { cn } from "@/app/lib/utils";

interface NavbarProps {
  isLoggedIn: boolean;
  username?: string;
}

export function AnimatedNavbar({ isLoggedIn, username }: NavbarProps) {
  const [isNavbarOpen, setIsNavbarOpen] = useState(true);
  const [oldScrollY, setOldScrollY] = useState(0);

  const isMobile = useMobile();
  const { scrollY } = useContext(ScrollContext);

  useEffect(() => {
    const navbarHeight = isMobile ? 64 : 65;
    if (scrollY <= navbarHeight) {
      setIsNavbarOpen(true);
    } else {
      if (oldScrollY < scrollY) {
        setIsNavbarOpen(false);
      } else {
        setIsNavbarOpen(true);
      }
    }

    setOldScrollY(scrollY);
  }, [scrollY, isMobile]);

  return (
    <>
      <div
        className={cn(
          "fixed left-0 right-0 z-[9999] transition-all duration-300",
        isNavbarOpen ? "top-0" : "md:-top-[200px] -top-[120px]"
      )}
    >
        <Navbar isLoggedIn={isLoggedIn} username={username} />
      </div>
      <div className="opacity-0 pointer-events-none">
        <Navbar isLoggedIn={isLoggedIn} username={username} />
      </div>
    </>
  );
}
